<template>
  <v-app>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="desserts"
    :single-select="singleSelect"
    item-key="MATERIAL_NUMBER"
    show-select
    style="padding:25px">

    <template v-slot:top>
      <div>
          <div>
            <v-toolbar style="box-shadow:none !important">
              <v-toolbar-title><b>{{title}}</b></v-toolbar-title>
              <v-spacer></v-spacer>
              
              <v-spacer></v-spacer>
              <v-breadcrumbs>Master Data / Initial Item</v-breadcrumbs>
              <v-btn icon v-on:click="getData">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-toolbar>

            <div style="padding:0px 25px">
                <v-layout row>
                  <v-flex md8></v-flex>
                  <v-flex md4>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field
                          
                          v-model="val"
                           v-on:keyup.enter="getData()"
                          placeholder="Enter Your Keywords"
                          solo
                          append-icon="search"
                        ></v-text-field>
                      </v-col>
                  </v-flex>

                </v-layout>   
            </div>
        </div>
      </div>

    </template>

    
  </v-data-table>
  </v-app>
</template>


<script>
export default {
    methods: {
        getData(){
         var self = this;
          var val  = self.val; 
         
          var url  = self.base_url + "master/initial_item";
          this.axios.post(url , {
              param:val,
          })
          .then(function (response) {
              self.desserts = response.data;
          });
      }
    },
    mounted(){
        this.getData();
    },
    data () { 
      return {
        name : "InitialItem",
        title : "Data Initial Item",
        dialog: false,
        widgets: false,
        singleSelect: false,
        selected: [],
        showSelect:false,
        val:'',
        headers: [
          { text: 'Material Number', value: 'MATERIAL_NUMBER',width:150},
          { text: 'Server Code', value: 'SERVER_CODE',width:150},
          { text: 'Description', value: 'DESCRIPTION',width:450},
          { text: 'Company ID', value: 'COMPANY_ID'},
          { text: 'Plant', value: 'PLANT'}, 
        ],
        desserts: [],
        modal_detail:false,
        detail:[],

        //storage.....................................
        storage_user_id : localStorage.getItem("user_id"),
        storage_username : localStorage.getItem("username"),
        storage_fullname : localStorage.getItem("fullname"),
        storage_company_id : localStorage.getItem("company_id"),
        storage_company_name : localStorage.getItem("company_name"),
        storage_role : localStorage.getItem("role"),
        storage_departement_id : localStorage.getItem("departement_id"),
        
      }
    },
  }
</script>
